// Generated by node storefront/events-build.cjs; edit storefront/analytics sources.
(function (root, factory) {
  const api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else root.FivePointEventContract = api;
})(globalThis, function () {
  'use strict';
  const token = v => typeof v === 'string' && /^[A-Za-z0-9][A-Za-z0-9:._/-]{0,191}$/.test(v);
  const count = v => Number.isSafeInteger(v) && v >= 0 && v <= 1000000000;
  const one = (...values) => v => values.includes(v);
  const result = one('success', 'empty', 'error', 'unknown');
  const rules = {
    page_viewed: {}, product_viewed: {}, collection_viewed: {collection_id: token},
    search_submitted: {query_length: count, result_count: count},
    product_added_to_cart: {}, product_removed_from_cart: {}, cart_viewed: {},
    checkout_started: {}, checkout_completed: {}, checkout_contact_info_submitted: {},
    checkout_address_info_submitted: {}, checkout_shipping_info_submitted: {}, payment_info_submitted: {},
    fp_module_view: {visible_ms: count},
    fp_product_view: {visible_ms: count},
    fp_entry_click: {entry: one('agent', 'finder', 'catalog', 'product', 'cart', 'member', 'search')},
    fp_search_submit: {query_length: count},
    fp_filter_apply: {filter_key: one('category', 'color', 'material', 'price', 'width', 'weight', 'availability', 'sort'), selected_count: count},
    fp_cart_write_result: {result: one('committed', 'rejected', 'unknown'), refresh_result: one('success', 'failed', 'not_attempted'), item_count: count},
    fp_finder_result: {result, result_count: count, duration_ms: count},
    fp_agent_turn_complete: {turn_id: token, result, result_count: count, duration_ms: count},
    fp_member_login: {result: one('success', 'cancelled', 'error')},
    fp_saved_import_complete: {imported_count: count, duplicate_count: count},
    fp_saved_change: {action: one('add', 'remove'), storage: one('local', 'account'), item_count: count},
    fp_compare_change: {action: one('add', 'remove'), item_count: count},
    fp_saved_import_result: {result: one('success', 'error', 'unknown'), requested_count: count},
    fp_member_profile_write: {section: one('profile', 'address'), action: one('add', 'update', 'remove'), result: one('success', 'error', 'unknown')},
    fp_interaction_error: {operation: one('cart', 'finder', 'agent', 'login', 'saved_import', 'search'), error_code: one('network', 'timeout', 'invalid_response', 'unauthorized', 'conflict', 'upstream', 'unknown')}
  };
  const optional = {search_submitted: ['result_count'], fp_finder_result: ['duration_ms'], fp_agent_turn_complete: ['duration_ms']};
  const itemEvents = new Set(['fp_product_view', 'fp_entry_click','product_viewed', 'product_added_to_cart', 'product_removed_from_cart', 'cart_viewed', 'checkout_started', 'checkout_completed']);
  const requireItems = new Set(['fp_product_view','product_viewed', 'product_added_to_cart', 'product_removed_from_cart']);
  const keys = new Set(['schema_version','event_id','event_name','occurred_at','anonymous_id','shopify_client_id','session_id','page_type','source_surface','component_id','page_version','consent_state','properties','items']);
  const object = v => v !== null && typeof v === 'object' && !Array.isArray(v);
  const money = v => typeof v === 'string' && /^(0|[1-9][0-9]{0,13})(\.[0-9]{1,6})?$/.test(v);
  function itemValid(item) {
    if (!object(item) || Object.keys(item).some(k => !['product_id','variant_id','quantity','amount','currency'].includes(k))) return false;
    if (!token(item.product_id) || (item.variant_id !== undefined && !token(item.variant_id)) || !Number.isSafeInteger(item.quantity) || item.quantity < 1 || item.quantity > 1000000) return false;
    if (item.amount === undefined && item.currency === undefined) return true;
    return money(item.amount) && typeof item.currency === 'string' && /^[A-Z]{3}$/.test(item.currency);
  }
  function validate(e) {
    if (!object(e) || Object.keys(e).some(k => !keys.has(k)) || !Object.hasOwn(rules, e.event_name)) return false;
    if (e.schema_version !== 1 || !token(e.event_id) || e.consent_state !== 'granted') return false;
    if (typeof e.occurred_at !== 'string' || !/^\d{4}-\d\d-\d\dT\d\d:\d\d:\d\d(?:\.\d+)?(?:Z|[+-]\d\d:\d\d)$/.test(e.occurred_at) || !Number.isFinite(Date.parse(e.occurred_at)) || Number(e.occurred_at.slice(0,4)) < 2000) return false;
    if (!['home','product','collection','search','cart','checkout','account','other'].includes(e.page_type) || !['storefront','member','finder','agent','header','catalog','cart','checkout'].includes(e.source_surface)) return false;
    if (['anonymous_id','shopify_client_id','session_id','component_id','page_version'].some(k => e[k] !== undefined && !token(e[k]))) return false;
    const props = e.properties === undefined ? {} : e.properties;
    if (!object(props)) return false;
    const rule = rules[e.event_name];
    if (Object.keys(props).some(k => !Object.hasOwn(rule,k) || !rule[k](props[k]))) return false;
    if (Object.keys(rule).some(k => !(optional[e.event_name] || []).includes(k) && !Object.hasOwn(props,k))) return false;
    if (e.items !== undefined && (!Array.isArray(e.items) || e.items.length > 100 || (!itemEvents.has(e.event_name) && e.items.length) || !e.items.every(itemValid))) return false;
    if(e.event_name==='fp_entry_click'&&e.items?.length&&(props.entry!=='product'||e.items.length!==1))return false;
    return !requireItems.has(e.event_name) || (Array.isArray(e.items) && e.items.length > 0);
  }
  function pageType(pathname) {
    if (pathname === '/') return 'home';
    for (const [prefix,type] of [['/products/','product'],['/collections/','collection'],['/search','search'],['/cart','cart'],['/checkouts/','checkout'],['/account','account']]) if (typeof pathname === 'string' && pathname.startsWith(prefix)) return type;
    return 'other';
  }
  return Object.freeze({validate, token, money, itemValid, pageType, names: Object.freeze(Object.keys(rules))});
});

(function(root,factory){
  const api=factory();
  if(typeof module==='object'&&module.exports)module.exports=api;
  else root.FivePointVisibility=api;
})(globalThis,function(){
  'use strict';
  function install(root,emit){
    const states=new Map(), completed=new Set();
    let frame=null, discoveryFrame=null;
    const allowed=()=>root.document.visibilityState==='visible'&&root.Shopify?.customerPrivacy?.analyticsProcessingAllowed()===true;
    function qualifies(node){
      if(!allowed()||!node.isConnected)return false;
      const r=node.getBoundingClientRect();
      const width=root.innerWidth,height=root.innerHeight;
      if(r.width<=0||r.height<=0||width<=0||height<=0)return false;
      const visibleWidth=Math.max(0,Math.min(r.right,width)-Math.max(r.left,0));
      const visibleHeight=Math.max(0,Math.min(r.bottom,height)-Math.max(r.top,0));
      return visibleWidth*visibleHeight>=0.5*Math.min(r.width*r.height,width*height);
    }
    function cancel(state){if(state.timer!==null)root.clearTimeout(state.timer);state.timer=null;}
    function check(){
      frame=null;
      for(const [node,state] of states){
        if(!node.isConnected){cancel(state);states.delete(node);continue;}
        if(completed.has(state.key)||!qualifies(node)){cancel(state);continue;}
        if(state.timer!==null)continue;
        state.timer=root.setTimeout(()=>{
          state.timer=null;
          if(completed.has(state.key)||!qualifies(node))return;
          const module=node.closest('[data-fp-event-module]'),surface=node.closest('[data-fp-event-surface]');
          const context={source_surface:surface?.dataset.fpEventSurface||'storefront'};
          if(module)context.component_id=module.dataset.fpEventModule;
          if(module?.dataset.fpPageVersion)context.page_version=module.dataset.fpPageVersion;
          if(state.product)context.items=[{product_id:node.dataset.fpProductId,quantity:1}];
          if(emit(state.product?'fp_product_view':'fp_module_view',{visible_ms:1000},context))completed.add(state.key);
        },1000);
      }
    }
    function schedule(){if(frame===null)frame=root.requestAnimationFrame(check);}
    function discover(){
      for(const node of root.document.querySelectorAll('[data-fp-event-module], [data-fp-product-id]')){
        const module=node.closest('[data-fp-event-module]'),product=node.dataset.fpProductId;
        const key=(module?.dataset.fpPageVersion||'')+':'+(module?.dataset.fpEventModule||'')+':'+(product?'product:'+product:'module');
        if(!states.has(node))states.set(node,{key,product:!!product,timer:null});
      }
      schedule();
    }
    root.addEventListener('scroll',schedule,{passive:true,capture:true});
    root.addEventListener('resize',schedule,{passive:true});
    root.addEventListener('load',schedule,true);
    // Cancel synchronously on privacy/visibility changes; do not count the gap.
    const reset=()=>{for(const state of states.values())cancel(state);schedule();};
    root.document.addEventListener('visibilitychange',reset);
    root.document.addEventListener('visitorConsentCollected',reset);
    root.document.addEventListener('shopify:section:load',discover);
    root.document.addEventListener('shopify:section:unload',schedule);
    if(root.MutationObserver){
      const observer=new root.MutationObserver(records=>{
        if(!records.some(r=>r.addedNodes.length||r.removedNodes.length)||discoveryFrame!==null)return;
        discoveryFrame=root.requestAnimationFrame(()=>{discoveryFrame=null;discover();});
      });
      observer.observe(root.document.documentElement,{childList:true,subtree:true});
    }
    discover();
    return {refresh:reset};
  }
  return {install};
});

(function (root, factory) {
  const contract = typeof module === 'object' && module.exports ? require('../analytics/event-contract.js') : root.FivePointEventContract;
  const api = factory(contract);
  if (typeof module === 'object' && module.exports) module.exports = api;
  else if (root.document) api.installTheme(root);
})(globalThis, function (contract) {
  'use strict';
  function installTheme(root) {
    if (root.FivePointEvents) return root.FivePointEvents;
    const diagnostic = code => root.console.warn('[FivePoint events]', code);
    function emit(name, properties = {}, context = {}) {
      try {
        if (!root.Shopify?.customerPrivacy || root.Shopify.customerPrivacy.analyticsProcessingAllowed() !== true) return false;
        if (!name.startsWith('fp_') || !root.Shopify?.analytics?.publish) { diagnostic('publisher_unavailable'); return false; }
        const allowedContext = ['page_type','source_surface','component_id','page_version','event_id','occurred_at','items'];
        if (Object.keys(context).some(k => !allowedContext.includes(k)) || (context.event_id && !context.occurred_at)) {diagnostic('invalid_context');return false;}
        const e = {schema_version:1,event_id:context.event_id || root.crypto.randomUUID(),event_name:name,occurred_at:context.occurred_at || new Date().toISOString(),page_type:context.page_type || contract.pageType(root.location.pathname),source_surface:context.source_surface || 'storefront',consent_state:'granted',properties};
        if (context.items !== undefined) e.items = context.items;
        if (context.component_id !== undefined) e.component_id = context.component_id;
        if (context.page_version !== undefined) e.page_version = context.page_version;
        if (!contract.validate(e)) { diagnostic('invalid_event'); return false; }
        const result = root.Shopify.analytics.publish(name, JSON.parse(JSON.stringify(e)));
        if (result && typeof result.catch === 'function') result.catch(() => diagnostic('publish_failed'));
        if (result === false) {diagnostic('publish_rejected');return false;}
        return e.event_id;
      } catch (_) { diagnostic('publish_failed'); return false; }
    }
    const api = Object.freeze({version:1,emit});
    root.FivePointEvents = api;
    // Exactly one delegated listener; repeated Shopify section loads are harmless.
    root.document.addEventListener('click', event => {
      const target = event.target?.closest?.('[data-fp-assistant-open], [data-assistant-open], .fp-finder-link, [data-fp-event-entry]');
      if (!target) return;
      const entry = target.matches('[data-fp-assistant-open], [data-assistant-open]') ? 'agent' : target.matches('.fp-finder-link') ? 'finder' : target.dataset.fpEventEntry;
      const surface=target.closest('[data-fp-event-surface]'), component=target.closest('[data-fp-event-module]');
      const context={source_surface:surface?.dataset.fpEventSurface||'storefront'};
      if(component)context.component_id=component.dataset.fpEventModule;
      if(entry==='product'){
        const product=target.matches('[data-fp-product-id]')?target:target.querySelector('[data-fp-product-id]');
        if(product)context.items=[{product_id:product.dataset.fpProductId,quantity:1}];
      }
      emit('fp_entry_click',{entry},context);
    });
    const visibility=root.FivePointVisibility?.install(root,emit);
    if (!root.Shopify?.customerPrivacy && root.Shopify?.loadFeatures) root.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}], error => {if (error) diagnostic('consent_api_unavailable');else visibility?.refresh();});
    return api;
  }
  return {installTheme};
});
